export default {
	coupon_items: [],
	redemption_items: [],
	trailer_items: [],
	all_items: [],
	timeline: "one_year",
	periodicity: "monthly",
	max_value: 0,
	min_value: 0,
}